﻿import React, { Fragment, useState, useEffect } from 'react';
import { FormTextInput, FormSelect } from "components/form-fields";
import { useValidation } from "hooks/useValidation";
import PropTypes from 'prop-types';
import { UserService } from 'services';

export function ApiApplicationBasicSettings(
    {
        saving = false,
        editing = false,
        application,
        loading,
        onSettingsUpdate,
        onValidationUpdate,
        pending,
        ssoAccount
    }
) {
    const [isValid, errors, validate] = useValidation();
    const [loadingValue, setLoading] = useState(true);
    const [appSettings, setAppSettings] = useState({ applicationName: null, role: {} });
    const [roles, setRoles] = useState([]);

    useEffect(initialLoad, []);

    function initialLoad() {
        UserService.getRoles().then(function (rolesResponse) {
            setRoles(rolesResponse.filter(r => r.settable));
        });
    }

    useEffect(onValidationChange, [isValid])

    function onValidationChange() {
        onValidationUpdate(isValid);
    }

    useEffect(() => {
        setAppSettings(application);
    }, [application]);

    useEffect(() => {
        setLoading(loading);
    }, [loading]);

    function onNameChange(event) {

        var updatedApp = {
            ...appSettings,
            applicationName: event.target.value
        }

        setAppSettings(updatedApp);
        onSettingsUpdate(updatedApp);
    }

    function onRoleChange(value) {
        var updatedApp = {
            ...appSettings,
            role: value
        }

        setAppSettings(updatedApp);
        onSettingsUpdate(updatedApp);
    }

    useEffect(updateValidationRules, [application])

    function updateValidationRules() {
        let rules = [{ fieldName: "applicationName", required: true }, { fieldName: "role", required: true }];
        validate(rules, application);
    }

    return (
        <Fragment>
            <FormTextInput
                id="application-name"
                loading={loadingValue}
                value={appSettings.applicationName}
                headingText="Application Name:"
                onChange={onNameChange}
                disabled={editing || saving || pending || ssoAccount}
                dangerHelperText={errors.applicationName}>
            </FormTextInput>
            <FormSelect
                id="application-role"
                disabled={saving}
                items={roles}
                onItemSelect={onRoleChange}
                placeholder="Select a role"
                headingText="Role:"
                selectedValue={appSettings.role.id}
                dangerHelperText={errors.role}
                loading={loadingValue}
            ></FormSelect>
        </Fragment>
    );
}

ApiApplicationBasicSettings.propTypes = {
    application: PropTypes.object.isRequired,
    saving: PropTypes.bool,
    editing: PropTypes.bool,
    loading: PropTypes.bool.isRequired
};